import React, { useEffect, useRef } from "react";

// Subtle sparkle trail following the cursor (desktop only, respects reduced-motion)
export const CursorSparkle = () => {
  const canvasRef = useRef(null);
  const particles = useRef([]);
  const raf = useRef(null);

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const coarse = window.matchMedia("(pointer: coarse)").matches;
    if (reduce || coarse) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let w = (canvas.width = window.innerWidth);
    let h = (canvas.height = window.innerHeight);
    const colors = ["#7DA083", "#D4AF37", "#CDBFA8", "#F5F2E9"];
    let last = 0;

    const onResize = () => {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
    };
    const onMove = (e) => {
      const now = Date.now();
      if (now - last < 28) return; // throttle ~30fps spawn
      last = now;
      for (let i = 0; i < 2; i++) {
        particles.current.push({
          x: e.clientX, y: e.clientY,
          vx: (Math.random() - 0.5) * 1.1,
          vy: (Math.random() - 0.5) * 1.1 - 0.3,
          life: 1, size: Math.random() * 3 + 1.5,
          color: colors[(Math.random() * colors.length) | 0],
        });
      }
    };

    const drawStar = (x, y, r, color, alpha) => {
      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.fillStyle = color;
      ctx.beginPath();
      for (let i = 0; i < 5; i++) {
        const ang = (Math.PI / 2) + (i * 2 * Math.PI) / 5;
        ctx.lineTo(x + Math.cos(ang) * r, y - Math.sin(ang) * r);
        const ang2 = ang + Math.PI / 5;
        ctx.lineTo(x + Math.cos(ang2) * (r / 2.3), y - Math.sin(ang2) * (r / 2.3));
      }
      ctx.closePath();
      ctx.fill();
      ctx.restore();
    };

    const loop = () => {
      ctx.clearRect(0, 0, w, h);
      particles.current = particles.current.filter((p) => p.life > 0);
      for (const p of particles.current) {
        p.x += p.vx; p.y += p.vy; p.vy += 0.02; p.life -= 0.025;
        drawStar(p.x, p.y, p.size, p.color, Math.max(0, p.life));
      }
      raf.current = requestAnimationFrame(loop);
    };

    window.addEventListener("resize", onResize);
    window.addEventListener("mousemove", onMove);
    loop();
    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf.current);
    };
  }, []);

  return <canvas ref={canvasRef} className="sparkle-canvas" aria-hidden="true" />;
};
